const toolbar = {
    options: [
      // "blockType",
      "fontFamily",
      "fontSize",
    "inline",
    "textAlign",
      "list",
      "colorPicker",
      "link",
      "embedded",
      "emoji",
    //   "image",
    //   "remove",
    //   "history"
    
    ],
    
    // blockType: {
    //   inDropdown: true,
    //   options: ["Normal", "H1", "H2", "H3", "H4", "H5", "H6", "Blockquote"],
    //   className: undefined,
    //   component: undefined,
    //   dropdownClassName: undefined
    // },

    // blockType: {
    //   inDropdown: true,
    //   options: ["Normal", "H1", "H2", "H3", "H4", "H5", "H6","Blockquote"],
    //   className: 'toolbar-item item-block-type',
    //   component: undefined,
    //   dropdownClassName: undefined
    // },
    
    fontFamily: {
      inDropdown: true,
      options: ["Helvetica", "Arial", "Georgia", "Impact", "Tahoma", "Sf pro", "Verdana"],
      className: 'toolbar-item item-block-type',
      component: undefined,
      dropdownClassName: undefined
    },

    fontSize: {
      inDropdown: true,
      options: [10, 12, 14, 18, 24, 30, 36, 48, 60, 72, 96],
      className: 'toolbar-item',
      component: undefined,
      dropdownClassName: undefined
    },
    
    
    inline: {
      inDropdown: false,
      className: 'toolbar-item',
      component: undefined,
      dropdownClassName: undefined,
      options: ["bold", "italic", "underline", "strikethrough"]
    },
    
    list: {
      inDropdown: false,
      className: 'toolbar-item',
      component: undefined,
      dropdownClassName: undefined,
      options: ["unordered"]
    },
    
    textAlign: {
      inDropdown: true,
      className: 'toolbar-item',
      component: undefined,
      dropdownClassName: undefined,
      options: ["left", "center", "right"]
    },
    
    colorPicker: {
      icon: '',
      className: 'toolbar-item change-color',
        component: undefined,
        popupClassName: undefined,
        colors: ["#000000", "#ffffff", "#ff0000", "#00ff00", "#0000ff", "#ffff00", "#00ffff", "#ff00ff", "#808080", "#800000", "#808000", "#008000", "#800080", "#008080", "#000080"],
      },
    
    link: {
      inDropdown: false,
      className: 'toolbar-item',
      component: undefined,
      popupClassName: undefined,
      options: ["link"],
      linkCallback: undefined
    },
    
    embedded: {
      icon: '',
      className: 'toolbar-item change-icon-embed',
      component: undefined,
      popupClassName: undefined,
      defaultSize: {
        height: "auto",
        width: "auto"
      }
    },
    
    emoji: {
      className: 'toolbar-item',
      component: undefined,
      popupClassName: undefined,
      emojis: [ 
        '😀', '😃', '😄', '😁', '😆', '😅', '😂', '🤣', '😊', '😇', '🙂', '🙃', '😉', '😌', '😍', '😘', '😗', '😙', '😚', '😋', '😛', '😜', '😝', '😎', '🤓', '🤗', '🤔', '😏', '😒', '😞', '😔', '😟', '😕', '🙁', '☹️', '😣', '😖', '😫', '😩', '😤', '😠', '😡', '😶', '😐', '😑', '😯', '😦', '😧', '😮', '😲', '😵', '😳', '😱', '😨', '😰', '😢', '😥', '🤤', '😭', '😓', '😪', '😴', '🙄', '🤔', '🤥', '😬', '🤐', '🤢', '🤧', '😷', '🤒', '🤕', '😈', '👿', '👹', '👺', '💀', '👻', '👽', '👾', '🤖', '💩', '😺', '😸', '😹', '😻', '😼', '😽', '🙀', '😿', '😾'
      ]
    },
    
    image: {
      className: 'toolbar-item',
      component: undefined,
      popupClassName: undefined,
      urlEnabled: true,
      uploadEnabled: true,
      alignmentEnabled: true,
      uploadCallback: undefined,
      previewImage: false,
      inputAccept: "image/gif,image/jpeg,image/jpg,image/png,image/svg"
    },
    
    // remove: {
    //   className: undefined,
    //   component: undefined
    // },
    
    // history: {
    //   inDropdown: false,
    //   className: undefined,
    //   component: undefined,
    //   dropdownClassName: undefined,
    //   options: ["undo", "redo"]
    // }
  };
  
  export default toolbar;
  